@if (deliveryDate != undefined) {
  <div class="delivery-date p-2">
    <span i18n="@@CartPreviewDeliveryDateLabel">Delivery for {{ deliveryDate | date: undefined : "UTC" }}</span>
  </div>
}
